module.exports = __webpack_public_path__ + "static/img/nals-thumb.ba98ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-thumb.png
// module id = sFge
// module chunks = 0